<template>
	<div class="page-content__content">
		<ManagersTable/>
	</div>
</template>

<script>
import ManagersTable from "@/components/sections/Managers/ManagersTable.vue";

export default {
	name: "ManagersPage",
	components: {ManagersTable},
}
</script>


